module.exports = __webpack_public_path__ + "media/img/frontend_application/free_trial/crm-2a01255872b2722c742d9d616a80137e.png";